<template>
  <v-layout>
    <v-col v-if="Mint.isForm" cols :sm="12" class="pa-0">
      <v-form v-model="Mint.isValid" ref="form">
        <v-card flat class="pt-5">
          <v-layout align-center class="px-3">
            <h2>{{ $t("menu.mint") }}</h2>
            <v-spacer></v-spacer>
            <v-icon @click="_fnReset()" color="primary"> mdi-close </v-icon>
          </v-layout>
          <v-card-text>
            <v-row>
              <v-col cols :sm="6" class="py-0">
                <v-typeMint v-model="Mint.obj.type" :rules="[Rules.required]" />
              </v-col>
              <v-col cols :sm="6" class="py-0">
                <v-text-field
                  color="primary"
                  :rules="[Rules.required]"
                  v-model="Mint.obj.name"
                >
                  <template #label>
                    {{ $t(`table.name`) }}
                    <span class="red--text">
                      <strong>*</strong>
                    </span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols :sm="6" class="py-0">
                <v-text-field
                  color="primary"
                  v-model="Mint.obj.amount"
                  :rules="[Rules.required]"
                  @input="(e) => e && fnNumberInput(Mint.obj, 'amount', e)"
                  @keypress="fnEventNumber($event)"
                >
                  <template #label>
                    {{ $t(`table.amount`) }}
                    <span class="red--text"><b>*</b></span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols :sm="6" class="py-0">
                <v-text-field
                  color="primary"
                  :rules="[Rules.required]"
                  v-model="Mint.obj.privateKey"
                >
                  <template #label>
                    {{ $t(`table.privateKey`) }}
                    <span class="red--text">
                      <strong>*</strong>
                    </span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols :sm="12" class="py-0">
                <v-textarea
                  color="primary"
                  :rules="[Rules.required]"
                  v-model="Mint.obj.description"
                >
                  <template #label>
                    {{ $t(`table.description`) }}
                    <span class="red--text"><b>*</b></span>
                  </template>
                </v-textarea>
              </v-col>
            </v-row>
            <v-row v-if="Mint.obj.type == '62b4209a6c7251ee1e094f30'">
              <v-col cols :sm="6" class="py-0">
                <v-upload
                  :size="200"
                  class="mb-3"
                  :label="$t(`table.image`)"
                  v-model="Mint.obj.image"
                  :rules="[Rules.required]"
                />
              </v-col>
            </v-row>

            <!-- <v-row v-if="Mint.obj.type == '623bf70563678cdc29ed0166'">
              <v-col cols :sm="12" class="pt-0 pb-3">
                <v-card>
                  <v-data-table
                    :items="Mint.obj.vouchers"
                    :headers="cTableHeaders"
                    :items-per-page="5"
                    item-key="item.id"
                    :search="search"
                    dense
                  >
                    <template v-slot:top>
                      <v-layout pa-2 justify-space-around align-end>
                        <v-layout align-center>
                          <v-btn
                            small
                            class="mr-3"
                            color="primary"
                            @click="$refs.input.click()"
                          >
                            Import
                          </v-btn>
                          <input
                            :style="{ display: 'none' }"
                            type="file"
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            ref="input"
                            @change="_fnImport()"
                          />
                          <v-btn small color="primary" @click="_fnExport()">
                            Export
                          </v-btn>
                        </v-layout>
                        <v-spacer />
                        <div class="mb-3" :style="{ width: '220px' }">
                          <v-text-field
                            v-model="search"
                            :placeholder="$t(`table.search`)"
                            single-line
                            hide-details
                            dense
                            append-outer-icon=""
                          />
                        </div>
                      </v-layout>
                    </template>
                    <template #[`item.user.name`]="{ item }">
                      <span v-if="item.user">
                        {{ "LomoId: " + item.user.lomoId }}<br />
                        {{ "Name: " + item.user.name }}<br />
                      </span>
                    </template>
                    <template #[`item.date`]="{ item }">
                      <span v-if="item.date">{{ item.date | mDateTime }}</span>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row> -->
          </v-card-text>
          <v-card-actions class="px-4">
            <v-spacer></v-spacer>
            <v-btn
              v-if="
                Mint.isUpdate && Mint.obj.status == '62b4209a6c7251ee1e094f31'
              "
              color="primary"
              :disabled="!Mint.isValid"
              @click="_fnApprove()"
              >{{ $t(`table.approve`) }}
            </v-btn>
            <v-btn
              color="primary"
              :disabled="!Mint.isValid"
              @click="Mint.isCreate ? _fnCreate() : _fnUpdate()"
              >{{ Mint.isCreate ? $t(`table.create`) : $t(`table.update`) }}
            </v-btn>
            <v-btn outlined color="primary" @click="_fnReset()">
              {{ $t(`table.cancel`) }}
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-col>

    <v-dialog
      v-if="Mint.isDelete"
      v-model="Mint.isDelete"
      persistent
      scrollable
      max-width="500"
    >
      <v-card>
        <v-card-title dense class="headline primary" />
        <v-card-text class="pt-2">
          {{ $t(`table.deleteMess`) }}
          <b>{{ Mint.obj.title }}</b>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="_fnDelete()">
            {{ $t(`table.delete`) }}
          </v-btn>
          <v-btn outlined color="primary" @click="_fnReset()">
            {{ $t(`table.cancel`) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  data: () => ({
    model: "Mint",
    vouchers: "",
    search: "",
  }),
  created() {
    this.cTableHeaders = [
      {
        text: this.$t(`table.voucher`),
        value: "code",
        width: "130px",
      },
      {
        text: this.$t(`table.name`),
        value: "user.name",
        width: "130px",
      },
      {
        text: this.$t(`table.date`),
        value: "date",
        width: "130px",
      },
    ];
  },
  methods: {
    _fnReset() {
      if (this.$refs.form) this.$refs.form.reset();
      this.fnResetFlagView(this.model);
    },
    _fnReFresh() {
      this._fnReset();
      this[this.model].isRefresh = true;
    },
    _fnConvert() {
      this[this.model].obj = {
        ...this[this.model].obj,
        amount: this.fnToNumber(this[this.model].obj.amount),
      };
    },
    async _fnCreate() {
      this._fnConvert();
      const { code } = await this.fnPost({
        url: `/v1/admin/mint`,
        model: this.model,
      });
      if (code === 200) {
        this._fnReFresh();
      }
    },
    async _fnUpdate() {
      this._fnConvert();
      const { code } = await this.fnPut({
        url: `/v1/admin/mint/${this[this.model].obj.id}`,
        model: this.model,
      });
      if (code === 200) {
        this._fnReFresh();
      }
    },
    async _fnApprove() {
      this._fnConvert();
      const { code } = await this.fnPut({
        url: `/v1/admin/mint/approve/${this[this.model].obj.id}`,
        model: this.model,
      });
      if (code === 200) {
        this._fnReFresh();
      }
    },
  },
};
</script>
